import type { Dispatch, ReactNode, SetStateAction } from 'react'
import { createContext, useState, useEffect } from 'react'

import { openMembersImportEventListener } from '@space-events/openMembersImport'

type MembersImportProviderProps = {
  children: ReactNode
}

type MembersImportContextProps = {
  isMembersImportOpen: boolean
  setIsMembersImportOpen: Dispatch<SetStateAction<boolean>>
}

export const MembersImportContext = createContext<MembersImportContextProps>(
  {} as MembersImportContextProps
)

export const MembersImportProvider = ({ children }: MembersImportProviderProps) => {
  const [isMembersImportOpen, setIsMembersImportOpen] = useState(false)

  useEffect(() => {
    const unsubscribe = openMembersImportEventListener(() => {
      setIsMembersImportOpen(true)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <MembersImportContext.Provider value={{ isMembersImportOpen, setIsMembersImportOpen }}>
      {children}
    </MembersImportContext.Provider>
  )
}
